import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AirspaceModule } from '@flyfreely-portal-ui/airspace';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { LoadingIndicatorModule } from '@flyfreely-portal-ui/loading-indicator';
import { MapModule } from '@flyfreely-portal-ui/map';
import { MapExternalMissionsDirective } from '@flyfreely-portal-ui/missions-shared';
import { MapNoticesDirective } from '@flyfreely-portal-ui/notices-shared';
import { SitesSharedModule } from '@flyfreely-portal-ui/sites-shared';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { ngfModule } from 'angular-file';
import { InlineModalModule } from 'libs/inline-modal/src/lib/inline-modal.module';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { CloneMissionLocationDialogue } from './clone-mission-location/clone-mission-location-dialogue.component';
import { GeometryUploadService } from './geometry-upload.service';
import { GeometryUploadDialogue } from './geometry-upload/geometry-upload-dialogue.component';
import { LocationDetailsDialogue } from './location-details/location-details-dialogue.component';
import { LocationDialoguesService } from './location-dialogues.service';
import { LocationEditDrawingComponent } from './location-edit-drawing/location-edit-drawing.component';
import { LocationEditV2Dialogue } from './location-edit-v2/location-edit-dialogue.component';
import { LocationTemplateFeaturesDialogue } from './location-template-features/location-template-features-dialogue.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationModule,
        ModalModule.forChild(),
        MapModule,
        LoadingIndicatorModule,
        SharedUiModule,
        ngfModule,
        TooltipModule,
        NgSelectModule,
        NgxLoadingModule,
        InlineModalModule,
        AirspaceModule,
        BsDatepickerModule,
        TimepickerModule,
        CollapseModule,
        EnhancedHelpModule,
        AnalyticsModule,
        SitesSharedModule,
        MapNoticesDirective,
        MapExternalMissionsDirective
    ],
    providers: [LocationDialoguesService, GeometryUploadService],
    bootstrap: [],
    declarations: [
        LocationDetailsDialogue,
        CloneMissionLocationDialogue,
        LocationEditV2Dialogue,
        GeometryUploadDialogue,
        LocationEditDrawingComponent,
        LocationTemplateFeaturesDialogue
    ],
    exports: [LocationEditDrawingComponent]
})
export class LocationsModule {}
